import { AxiosInstance, AxiosRequestConfig } from "axios";

export class AuthInjector {
  static Add(instance: AxiosInstance): number {
    function AuthTokenInject(
      requestConfig: AxiosRequestConfig
    ): AxiosRequestConfig {
      const token = localStorage.getItem("token");

      const header = {
        authorization: !!token ? `Bearer ${token}` : "",
      };

      const headers = {
        ...(requestConfig.headers ?? {}),
        ...header,
      };

      return { ...requestConfig, headers };
    }

    return instance.interceptors.request.use(AuthTokenInject);
  }

  static Remove(instance: AxiosInstance, id: number): void {
    instance.interceptors.request.eject(id);
  }
}
